/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {QrForBroker} from './QrForNHSV/QrForBroker'
import {QrForMarketing} from './QrForNHSV/QrforMKT'
import {HeaderUserMenu} from '../../../../_metronic/partials'
import {useNavigate} from 'react-router-dom'
import {QrForAll} from './QrForNHSV/QrForAll'

const OpenQr: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const [tab, setTab] = useState('Người chăm sóc')
  const history = useNavigate()
  const currentUser: any = localStorage.getItem('currentUser')
  const checkCurrentUser = JSON.parse(currentUser) ? JSON.parse(currentUser)?.myBool : false

  useEffect(() => {
    if (checkCurrentUser) {
      history('/open-account/auth/createQr')
    } else {
      history('/open-account/auth/sign-in')
    }
  }, [checkCurrentUser, history])

  return (
    <>
      <HeaderUserMenu />
      <div
        className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
        style={{
          backgroundColor: 'rgb(235 243 243)',
        }}
      >
        <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
          <div className='mb-12'>
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/logos/nhsv-logo-horizontal-light.svg')}
              className='h-45px'
            />
          </div>
          <div className='w-lg-1000px bg-body rounded shadow-sm p-lg-15 mx-auto'>
            <ul
              className='nav nav-stretch nav-line-tabs
            fw-bold
            border-transparent
            flex-nowrap
          '
              role='tablist'
            >
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 'Người chăm sóc'})}
                  onClick={() => setTab('Người chăm sóc')}
                  role='tab'
                >
                  Người chăm sóc
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 'Người giới thiệu'})}
                  onClick={() => setTab('Người giới thiệu')}
                  role='tab'
                >
                  Người giới thiệu
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 'Tất cả'})}
                  onClick={() => setTab('Tất cả')}
                  role='tab'
                >
                  Tất cả
                </a>
              </li>
            </ul>

            <div className='card-body'>
              <div className='tab-content pt-3'>
                <div className={clsx('tab-pane', {active: tab === 'Người chăm sóc'})}>
                  <QrForBroker />
                </div>

                <div className={clsx('tab-pane', {active: tab === 'Người giới thiệu'})}>
                  <QrForMarketing />
                </div>
                <div className={clsx('tab-pane', {active: tab === 'Tất cả'})}>
                  <QrForAll />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {OpenQr}
